'use strict';

module Patersons {

    export class UnrealisedCapitalGainsReport extends AbstractReport {
        assetClasses: UnrealisedCapitalGainsAssetClass[];
        total: UnrealisedCapitalGain;
        //getPdfFile() {
        //    return null;  //not implemented yet
        //}
    }

    export class UnrealisedCapitalGainsAssetClass {
        name: string;
        assets: UnrealisedCapitalGainsAsset[];
        subtotal: UnrealisedCapitalGain;
    }

    export class UnrealisedCapitalGainsAsset {
        name: string;
        capitalGains: UnrealisedCapitalGain[];
        subtotal: UnrealisedCapitalGain;
    }

    export class UnrealisedCapitalGain {
        purchaseDate: Date;
        quantity: number;
        marketValue: number;
        totalCost: number;
        costPrice: number;
        marketPrice: number;
        reducedCostBase: number;
        indexedCostBase: number;
        discountedCostBase: number;
        capitalLoss: number;
        indexedGain: number;
        grossDiscountGain: number;
        otherGain: number;
    }

    export class UnrealisedCapitalGainsReportComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/portfolioSummary/components/unrealisedCapitalGainsReport.component.html';
        controller: any = UnrealisedCapitalGainsReportController;
        bindings: any = {
            report: '<',
            title: '@'
        };
    }

    export class UnrealisedCapitalGainsReportController extends AbstractReportController {
        report: UnrealisedCapitalGainsReport;
    }

}

